var SmartController = window.SmartController || (window.SmartController = {});
(function (sg) {
    'use strict';

    sg.type = "";
    sg.appName = "SMART2";
    sg.create = createFunc;
    sg.createService = createServFunc;
    sg.createProvider = createProviderFunc;


    function createFunc(name, dependencies, forceRegister) {
        if (this.type === "launcher" || forceRegister === false || !angular.module(this.appName).controllerProvider) {
            return angular.module(this.appName).controller(name, dependencies);
        } else {
            return angular.module(this.appName).controllerProvider.register(name, dependencies);
        }
    }
    function createServFunc(name, dependencies, forceRegister) {
        if (this.type === "launcher" || forceRegister === false || !angular.module(this.appName).provide) {
            return angular.module(this.appName).service(name, dependencies);
        } else {
            return angular.module(this.appName).provide.service(name, dependencies);
        }
    }
    function createProviderFunc(name, dependencies, forceRegister) {
        if (this.type === "launcher" || forceRegister === false || !angular.module(this.appName).provide) {
            return angular.module(this.appName).provider(name, dependencies);
        } else {
            return angular.module(this.appName).provide.provider(name, dependencies);
        }
    }
})(SmartController);
